var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOff = function SvgEyeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.141,
    height: 31.524
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.476 25.04a14.03 14.03 0 0 1-8.19 2.8C7.634 27.836 2.119 16.977 2.119 16.977a25.15 25.15 0 0 1 6.977-8.058m5.295-2.47a12.8 12.8 0 0 1 2.895-.33c9.652 0 15.167 10.858 15.167 10.858a25 25 0 0 1-2.978 4.33m-9.266-1.452a4.18 4.18 0 0 1-4.05 1.169 4.1 4.1 0 0 1-2.984-2.938 4.03 4.03 0 0 1 1.188-3.987M2.119 2.119l29.903 27.286"
  }))));
};
export default SvgEyeOff;